import { useEffect, useState, useCallback, useContext } from 'react';
import { Form, Select } from 'antd';
import {
  ISettingProperties,
  ISettingToUpdate,
} from '../../interfaces/TenantSetting';
import { Query } from '../../services/graphql/query';
import GraphqlService from '../../services/graphql/GraphqlService';
import { ISettingType } from '../../interfaces/TenantSetting';
import './TenantSettingSelect.less';
import { IReceiptType } from '../../interfaces/Receipt';
import { ContextApp } from '../../contexts/ContextApp';

type Props = {
  settingsArray: ISettingToUpdate[];
  handleChange: (id: any, value: any) => void;
};

export const useSettingAllReceiptTypes = (props: Props) => {
  const { settingsArray, handleChange } = props;
  const [receiptTypes, setReceiptTypes] = useState<IReceiptType[]>([]);
  const { customRequest } = GraphqlService();
  const { selectedTenantId } = useContext(ContextApp);

  useEffect(() => {
    getReceiptTaxTypes(selectedTenantId);
  }, [selectedTenantId]);

  const getReceiptTaxTypes = async (tenantId: number | undefined) => {
    const data: IReceiptType[] = await customRequest({
      query: Query.receipTypes,
      variables: { filter: { tenant_id: tenantId, active: true, } },
    });
    setReceiptTypes(data);
  };

  const AllReceiptTypeSelect = useCallback(
    (props: ISettingProperties) => {
      const valueSelected = settingsArray
        .find((item) => item.id === props.id)
        ?.value?.toString();

      return (
        <Form.Item
          className="margin-component"
          required
          key={props.key || undefined}
        >
          {!receiptTypes.length || !settingsArray.length ? (
            <Select loading className="setting-select" />
          ) : (
            <Select
              className="setting-select"
              onChange={(e) => handleChange(props.id, e)}
              getPopupContainer={(node) => node.parentNode}
              value={valueSelected}
              options={receiptTypes.map((item) => ({
                label: item.name,
                value: item.id.toString(),
              }))}
            ></Select>
          )}
        </Form.Item>
      );
    },
    [receiptTypes, settingsArray],
  );

  const allReceiptTypeSetting: ISettingType = {
    render: useCallback(
      (props) => {
        return <AllReceiptTypeSelect {...props} />;
      },
      [receiptTypes, settingsArray],
    ),
  };

  return { allReceiptTypeSetting };
};

export default useSettingAllReceiptTypes;
